import { queryStringService, themeService } from '@/services';
import { isOrigemInter } from '@shared/inter/utils/isOrigemInter';

/** Tema da marca Acerto. Os demais pintam o portal com a marca de um parceiro. */
const TEMA_DA_ACERTO = 'portal';

/** `utm_source` com que o card do SuperApp do Inter marca quem manda para cá. */
const UTM_SOURCE_APP_INTER = 'app_inter';

/**
 * `isOrigemInter` só reconhece o SuperApp pelo `utmSource` do token, que não existe antes do login.
 * Como a instalabilidade é decidida ao montar o `App` e o login não recarrega a página, quem entra
 * pelo card do Inter ainda deslogado precisa ser reconhecido pela query string guardada na entrada.
 */
function veioDoSuperAppInter(): boolean {
  return queryStringService.getFromStorage().utm_source === UTM_SOURCE_APP_INTER;
}

/**
 * A experiência de PWA (instalação, ícone na tela inicial e notificação push) é da marca Acerto.
 * O tema `portal` sozinho não basta: o SuperApp do Inter é forçado para `portal` pelo
 * `ThemeService`, então a origem Inter também precisa ser descartada.
 */
export function pwaHabilitado(): boolean {
  return themeService.getCurrentTheme() === TEMA_DA_ACERTO && !isOrigemInter() && !veioDoSuperAppInter();
}
